import * as types from '../wizard/actions/types';
import * as util from './metadataFunctions'

const initialState = {
  savedBundles: null,
  savedMapping: null,
  savedConfiguration: null,
  savedTrigger:null,
  savedCredentials:null,
  loaded:false,     // saved config data has been loaded from backend
  dataLoaded:false, // loaded data entered into redux-form
  sourceCheckResult:null,
  destinationCheckResult:null,
  sourceMetadata:null,
  destinationMetadata:null,
  gettingScenario:false,
  gotScenario:false,
  oauthUrl:null,
  gettingOauthUrl:false,
  environments:null,
  ongoingExecutionLogs: [],
  ongoingExecutionLogCount: null,
};

export default function wizardReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SET_WIZARD_SAVED_BUNDLES:
      return {
        ...state,
        savedBundles: action.data
      }
    case types.SET_WIZARD_SAVED_MAPPING:
      return {
        ...state,
        savedMapping: action.data
      }
    case types.SET_WIZARD_TRIGGER:
      return {
        ...state,
        savedTrigger: action.data
      }
    case types.SET_WIZARD_SAVED_CONFIGURATION:
      return {
        ...state,
        savedConfiguration: action.data
      }
    case types.SET_WIZARD_SAVED_CREDENTIALS:
      return {
        ...state,
        savedCredentials: action.data
      }
    case types.SET_WIZARD_ENVIRONMENTS:
      return {
        ...state,
        environments: action.data
      };
    case types.SET_WIZARD_LOADED:
      return {
        ...state,
        loaded: action.bool
      };
    case types.SET_WIZARD_DATA_LOADED:
      return {
        ...state,
        dataLoaded: action.bool
      };
    case types.START_WIZARD_ENV_CHECK:
      return {
        ...state,
        [`${action.mode}CheckResult`]:null,
        [`${action.mode}Metadata`]:null,
      }
    case types.FINISH_WIZARD_ENV_CHECK:
      let schema = null
      if(action.data.metadata){
        schema = util.metadataFunctions(action.data.metadata, action.data.providerType)
      }
      const hasMetadata = schema && schema.length
      return {
        ...state,
        [`${action.data.mode}CheckResult`]:hasMetadata?action.data.code:'',
        [`${action.data.mode}Metadata`]:schema,
        [`${action.data.mode}CheckError`]:action.data.err,
      }
    case types.START_WIZARD_GET_SCENARIO:
      return {
        ...state,
        gettingScenario:true,
        gotScenario:false,
      }
    case types.FINISH_WIZARD_GET_SCENARIO:
      return {
        ...state,
        gettingScenario:false,
        gotScenario:true,
      }
    case types.SET_WIZARD_ONGOING_EXECUTION_LOGS:
      return {
        ...state,
        ongoingExecutionLogs: action.data && 
          action.data.sort((a,b)=>a.sortOrder-b.sortOrder),
      };
    case types.SET_WIZARD_ONGOING_EXECUTION_LOG_COUNT:
      return {
        ...state,
        ongoingExecutionLogCount: action.data,
      };
    case types.GETTING_WIZARD_OAUTH_URL:
      return {
        ...state,
        oauthUrl: null,
        gettingOauthUrl: action.bool,
        [`${action.mode}CheckResult`]:null,
      }
    case types.SET_WIZARD_OAUTH_URL:
      return {
        ...state,
        oauthUrl: action.data,
        gettingOauthUrl: false
      }
    case types.CLEAR_WIZARD:
      return {
        ...initialState
      }
    default: return state;
  }
};




// WEBPACK FOOTER //
// ./src/lib/reducer/wizard.js